
<template>
  <div
    class="foot"
    :class="getSystem() == 'PC' ? 'pc':'wap'"
  >
    <div class="logo">
      <img src="https://gw-apk.resources.rastargames.com/gw-front/resources/msrsea/images/etolies.png">
      <img
        v-if="name == 'msrsea'"
        src="https://gw-apk.resources.rastargames.com/gw-front/resources/msrsea/images/nexon.png"
      >
      <img
        v-if="XhLang === 'vn'"
        src="https://gw-apk.resources.rastargames.com/gw-front/resources/msrsea/images/wetaps.png"
      >
    </div>
    <ul>
      <li>
        <a
          href="https://sea-pc.rastargames.com/protocol/rules.html"
          target="_blank"
        >{{ $t('foot.termsOfService') }}</a>
      </li>
      <li>
        <a
          href="https://sea-pc.rastargames.com/protocol/privacy.html"
          target="_blank"
        >{{ $t('foot.privacyPolicy') }}</a>
      </li>
      <li v-if="$t('foot.Notice') && type !=='gw'">
        <router-link
          v-if="isNa"
          to="/protocol-na"
          target="_blank"
        >
          {{ $t('foot.Notice') }}
        </router-link>
        <router-link
          v-else
          to="/protocol"
          target="_blank"
        >
          {{ $t('foot.Notice') }}
        </router-link>
      </li>
    </ul>
    <p
      id="copyText"
      @click="copy"
    >{{ $t('foot.EmailText') }}{{email}}</p>
    <i v-if="name == 'msrsea'">{{$t('foot.info')}}</i>
    <i v-if="$t('foot.info1')">{{$t('foot.info1')}}</i>
    <i v-if="$t('foot.info2')">{{$t('foot.info2')}}</i>
    <i v-if="$t('foot.info3')">{{$t('foot.info3')}}</i>
    <i v-if="$t('foot.info4')">{{$t('foot.info4')}}</i>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps(["email", "name", "type"]);

import { useI18n } from "vue-i18n";
const { t, locale } = useI18n();

import { getSystem } from "../util/base";

import useClipboard from "vue-clipboard3";
import { ElMessage } from "element-plus";

import { projectType } from "@/util/global";
const isNa = projectType().area.indexOf("na") !== -1;

const { toClipboard } = useClipboard();

const XhLang = locale.value;

const copy = async () => {
  try {
    await toClipboard(props.email);
    ElMessage({
      message: t("copySuccess"),
      center: true,
      offset: 200,
      type: "success",
    });
  } catch (e) {
    ElMessage({
      message: t("copyFail"),
      center: true,
      offset: 200,
      type: "error",
    });
  }
};
</script>

<style lang="scss" scoped>
$primary-color: #404247;
$secondary-color: #586981;

// 移动端样式
.foot {
  padding: 0.15rem 0;
  text-align: center;
  line-height: 0.5rem;
  font-weight: bold;

  ul {
    display: flex;
    justify-content: center;
    font-size: 0.29rem;

    li {
      padding: 0 0.15rem;
      height: 0.35rem;
      line-height: 0.35rem;
      margin: 0.15rem 0;
      border-right: 1px solid $primary-color;

      &:last-child {
        border-right: none;
      }

      a {
        color: $primary-color;
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }

  p {
    font-size: 0.24rem;
    color: $primary-color;
    cursor: pointer;
  }

  i {
    font-size: 0.18rem;
    display: block;
    color: $secondary-color;
  }

  .logo {
    display: flex;
    justify-content: center;
    margin-bottom: 0.25rem;
    align-items: flex-end;

    img {
      margin: 0 0.5rem;
    }

    img:nth-child(1) {
      width: 2.22rem;
    }

    img:nth-child(2) {
      width: 1.5rem;
    }

    img:nth-child(3) {
      width: 0.76rem;
    }
  }
}
</style>